import React from 'react'
import { ConfigContext } from './ConfigProvider'

const useConfig = () => React.useContext(ConfigContext)
export default useConfig

